// extracted by mini-css-extract-plugin
module.exports = {"outer":"_3Cznt","middleComponentStyles":"SU0eP","footerStyles":"_3sen6","rightColStyles":"_3BNHA","verifiedMessage":"b8sVg","message":"_2vjWv"};